'use client';

import { PageGlobalStyle } from './page-global-style';

function activateThemeColor(element: HTMLMetaElement | null) {
  if (!element) return;

  element.media = '';

  return () => {
    element.media = 'not all';
  };
}

/**
 * Sets the Safari toolbar color and body background for iOS Safari.
 *
 * - Safari 15-18: Uses <meta name="theme-color"> to tint the toolbar areas
 *   (Dynamic Island region and bottom URL bar).
 * - Safari 26+: Derives toolbar color from body/fixed-element background-color.
 *
 * Content never renders behind the Dynamic Island or URL bar in regular Safari.
 * This component makes the toolbar areas match the page background for a
 * seamless appearance.
 */
export function DarkBackgroundStyle({ color }: { color: string }) {
  return (
    <>
      <meta ref={activateThemeColor} name="theme-color" content={color} />
      <PageGlobalStyle>{`html, body { background-color: ${color} !important; }`}</PageGlobalStyle>
    </>
  );
}
